import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Group } from '../components/dobles/dobles.entities';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class InformesService {
  private rootEndPoint;
  constructor(private _http:HttpClient) {
    this.rootEndPoint = 'cartera-vencida'
  }

  public reporteCarteraIndividual(database,fechaI,fechaF):Observable<Array<Group>>{
    return this._http.get<Array<Group>>(`${environment.api}${this.rootEndPoint}/individuales/${database}/${fechaI}/${fechaF}`).pipe(

        map(succ=>{
          const formatted = succ.map(grupos=>{
            grupos.bills.map(bill=>{
              console.log(bill)
              console.log(moment(bill.CARFVN).diff(bill.FechaFac));
            })
          })
          return succ;
        })
    );
  }
}
